module.exports = __webpack_public_path__ + "static/media/navbar-background.03adb7aa.svg";